export default __webpack_public_path__ + "static/media/control-icon.1bb7da8d.svg";